import { useMemo } from 'react';
import { FormField, StepConfig } from '../../type';

export type StepGroup = {
  stepIndex: number;
  config: StepConfig;
  fields: FormField[];
};

type Args = {
  fields: FormField[];
  steps: StepConfig[];
};

const useStepGroups = ({ fields, steps }: Args): StepGroup[] =>
  useMemo(
    () =>
      steps.map((config, index) => {
        const stepNumber = index + 1;
        return {
          stepIndex: index,
          config,
          fields: fields.filter((f) => (f.step ?? 1) === stepNumber),
        };
      }),
    [fields, steps],
  );

export default useStepGroups;
